import React, { Component } from "react";
import {
  Button,
  Col,
  FormControl,
  Grid,
  Modal,
  OverlayTrigger,
  Panel,
  Row,
  Table,
  Tooltip,
} from "react-bootstrap";
import {
  getAdminPickupOrders,
  getServicePartners,
  updateAdminPickupOrderStatuses,
} from "api/service partner/PartnerApi";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import "./partners.css";

const EMPTY_FILTERS = {
  partner_id: "",
  order_id: "",
  status: "",
  payment_type: "",
  is_claimable: "",
};

const PICKUP_STATUSES = [
  { id: 1, label: "Submitted" },
  { id: 2, label: "Processing" },
  { id: 9, label: "Quote Sent" },
  { id: 10, label: "Contacted" },
  { id: 12, label: "Ready" },
  { id: 4, label: "Completed" },
  { id: 5, label: "Cancelled" },
];

const STATUS_CLASS_NAMES = {
  1: "submitted",
  2: "processing",
  4: "completed",
  5: "cancelled",
  9: "quote-sent",
  10: "contacted",
  12: "ready",
};

class PickupOrders extends Component {
  state = {
    filters: { ...EMPTY_FILTERS },
    orders: [],
    partners: [],
    currentPage: 1,
    lastPage: 1,
    total: 0,
    loading: false,
    error: "",
    success: "",
    selectedOrderIds: [],
    bulkStatus: "",
    updatingStatuses: false,
    showStatusConfirmation: false,
    fileModal: null,
  };

  componentDidMount() {
    const token = this.token();
    getServicePartners("", "", 1, 100, token).then((res) => {
      const page = res.data || {};
      this.setState({ partners: Array.isArray(page.data) ? page.data : [] });
    });
    this.loadOrders(1);
  }

  token = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.token;
  };

  loadOrders = (page) => {
    this.setState({ loading: true, error: "" });
    getAdminPickupOrders(
      { ...this.state.filters, page, records_per_page: 20 },
      this.token(),
    )
      .then((res) => {
        const pagination = res.data || {};
        this.setState({
          orders: Array.isArray(pagination.data) ? pagination.data : [],
          selectedOrderIds: [],
          currentPage: pagination.current_page || 1,
          lastPage: pagination.last_page || 1,
          total: pagination.total || 0,
          loading: false,
        });
      })
      .catch((error) =>
        this.setState({ loading: false, error: getApiErrorMessage(error) }),
      );
  };

  onFilterChange = (event) => {
    const { name, value } = event.target;
    this.setState((state) => ({
      filters: { ...state.filters, [name]: value },
    }));
  };

  toggleOrder = (orderId) => {
    this.setState((state) => ({
      selectedOrderIds: state.selectedOrderIds.includes(orderId)
        ? state.selectedOrderIds.filter((id) => id !== orderId)
        : [...state.selectedOrderIds, orderId],
      success: "",
    }));
  };

  toggleAllOrders = () => {
    this.setState((state) => {
      const visibleIds = state.orders.map((order) => order.order_id);
      const allSelected = visibleIds.every((id) =>
        state.selectedOrderIds.includes(id),
      );

      return { selectedOrderIds: allSelected ? [] : visibleIds };
    });
  };

  updateSelectedStatuses = () => {
    const { selectedOrderIds, bulkStatus } = this.state;
    if (!selectedOrderIds.length || !bulkStatus) return;

    this.setState({ showStatusConfirmation: true });
  };

  confirmStatusUpdate = () => {
    const { selectedOrderIds, bulkStatus } = this.state;
    if (!selectedOrderIds.length || !bulkStatus) return;

    this.setState({
      showStatusConfirmation: false,
      updatingStatuses: true,
      error: "",
      success: "",
    });
    updateAdminPickupOrderStatuses(selectedOrderIds, bulkStatus, this.token())
      .then((res) => {
        const updatedStatus = res.data.status;
        this.setState((state) => ({
          orders: state.orders.map((item) =>
            selectedOrderIds.includes(item.order_id)
              ? { ...item, status: updatedStatus }
              : item,
          ),
          selectedOrderIds: [],
          bulkStatus: "",
          updatingStatuses: false,
          success: res.message || "Pickup order statuses updated successfully.",
        }));
      })
      .catch((error) =>
        this.setState({
          updatingStatuses: false,
          error: getApiErrorMessage(error),
        }),
      );
  };

  renderStatus = (status, cancelReason, orderId) => {
    if (!status) return "-";

    const statusId = Number(status.id || status.value || status.status_id);
    const className = STATUS_CLASS_NAMES[statusId] || "default";
    const reason = String(cancelReason || "").trim();
    const badge = (
      <span className={`pickup-status-badge pickup-status-${className}`}>
        <span className="pickup-status-dot" aria-hidden="true" />
        {status.label || "Unknown"}
      </span>
    );

    if (statusId !== 5 || !reason) return badge;

    return (
      <span className="pickup-status-with-reason">
        {badge}
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`pickup-cancel-reason-${orderId}`}>
              <strong>Cancellation reason:</strong> {reason}
            </Tooltip>
          }
        >
          <button
            type="button"
            className="pickup-cancel-reason-button"
            aria-label={`View cancellation reason: ${reason}`}
          >
            <i className="fa fa-info-circle" aria-hidden="true" />
          </button>
        </OverlayTrigger>
      </span>
    );
  };

  openFileModal = (order, fileType) => {
    const isBill = fileType === "bill";
    const files = isBill ? order.partner_bill_url : order.prescription_details;

    this.setState({
      fileModal: {
        title: isBill ? "Bills" : "Prescriptions",
        orderId: order.order_id,
        files: Array.isArray(files) ? files : [],
        urlKey: isBill ? "bill_url" : "prescription_file",
      },
    });
  };

  renderFileButton = (order, fileType) => {
    const files =
      fileType === "bill" ? order.partner_bill_url : order.prescription_details;
    const count = Array.isArray(files) ? files.length : 0;

    if (!count) return "-";

    return (
      <Button
        bsStyle="info"
        bsSize="xsmall"
        className="pickup-file-button"
        onClick={() => this.openFileModal(order, fileType)}
      >
        <i className="fa fa-eye" aria-hidden="true" /> View
        <span className="pickup-file-count">{count}</span>
      </Button>
    );
  };

 

  render() {
    const { filters, orders, currentPage, lastPage } = this.state;
    return (
      <div className="main-content partners-page">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Panel>
                <Panel.Body>
                  <div className="partners-filter-card">
                    <div className="partners-filter-grid pickup-order-filter-grid">
                      <FormControl
                        componentClass="select"
                        name="partner_id"
                        value={filters.partner_id}
                        onChange={this.onFilterChange}
                      >
                        <option value="">All Partners</option>
                        {this.state.partners.map((partner) => (
                          <option key={partner.id} value={partner.id}>
                            {partner.partner_name}
                          </option>
                        ))}
                      </FormControl>
                      <FormControl
                        name="order_id"
                        value={filters.order_id}
                        onChange={this.onFilterChange}
                        placeholder="Order ID"
                        style={{ marginBottom: "1px" }}
                      />
                      <FormControl
                        componentClass="select"
                        name="status"
                        value={filters.status}
                        onChange={this.onFilterChange}
                      >
                        <option value="">All Statuses</option>
                        {PICKUP_STATUSES.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.label}
                          </option>
                        ))}
                      </FormControl>
                      <FormControl
                        componentClass="select"
                        name="payment_type"
                        value={filters.payment_type}
                        onChange={this.onFilterChange}
                      >
                        <option value="">All Payment Types</option>
                        <option value="Cash">Cash</option>
                        <option value="Card">Card</option>
                        <option value="ComBank">ComBank</option>
                      </FormControl>
                      <FormControl
                        componentClass="select"
                        name="is_claimable"
                        value={filters.is_claimable}
                        onChange={this.onFilterChange}
                      >
                        <option value="">All Orders</option>
                        <option value="1">Claim Orders</option>
                        <option value="0">Non-claim Orders</option>
                      </FormControl>
                      <div>
                        <Button
                          bsStyle="info"
                          onClick={() => this.loadOrders(1)}
                        >
                          Search
                        </Button>{" "}
                        <Button
                          onClick={() =>
                            this.setState(
                              { filters: { ...EMPTY_FILTERS } },
                              () => this.loadOrders(1),
                            )
                          }
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                  {this.state.error && (
                    <div className="alert alert-danger">{this.state.error}</div>
                  )}
                  {this.state.success && (
                    <div className="alert alert-success">
                      {this.state.success}
                    </div>
                  )}
                  <div
                    className={`pickup-bulk-status-bar ${
                      this.state.selectedOrderIds.length ? "has-selection" : ""
                    }`}
                  >
                    <div
                      className="pickup-selection-summary"
                      aria-live="polite"
                    >
                      <span className="pickup-selection-count">
                        {this.state.selectedOrderIds.length}
                      </span>
                      {this.state.selectedOrderIds.length === 1
                        ? "order selected"
                        : "orders selected"}
                    </div>
                    <FormControl
                      componentClass="select"
                      value={this.state.bulkStatus}
                      disabled={this.state.updatingStatuses}
                      onChange={(event) =>
                        this.setState({ bulkStatus: event.target.value })
                      }
                    >
                      <option value="">Select new status</option>
                      {PICKUP_STATUSES.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.label}
                        </option>
                      ))}
                    </FormControl>
                    <Button
                      bsStyle="info"
                      disabled={
                        this.state.updatingStatuses ||
                        !this.state.selectedOrderIds.length ||
                        !this.state.bulkStatus
                      }
                      onClick={this.updateSelectedStatuses}
                    >
                      {this.state.updatingStatuses
                        ? "Updating..."
                        : "Change Status"}
                    </Button>
                  </div>
                  <Table responsive striped hover>
                    <thead>
                      <tr>
                        <th className="pickup-checkbox-column">
                          <input
                            type="checkbox"
                            aria-label="Select all orders on this page"
                            checked={
                              orders.length > 0 &&
                              orders.every((order) =>
                                this.state.selectedOrderIds.includes(
                                  order.order_id,
                                ),
                              )
                            }
                            onChange={this.toggleAllOrders}
                          />
                        </th>
                        <th>Lead Name</th>
                        <th>Order ID</th>
                        <th>Partner</th>
                        <th>Status</th>
                        <th>Payment Type</th>
                        <th>Claim</th>
                        <th>Claim Value</th>
                        <th>Used Flash Credit</th>
                        <th>Total Amount</th>
                        <th>Collecting Amount</th>
                        <th>Bill</th>
                        <th>Prescription</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!this.state.loading &&
                        orders.map((order) => (
                          <tr key={order.order_id}>
                            <td className="pickup-checkbox-column">
                              <input
                                type="checkbox"
                                aria-label={`Select order ${order.order_id}`}
                                checked={this.state.selectedOrderIds.includes(
                                  order.order_id,
                                )}
                                onChange={() =>
                                  this.toggleOrder(order.order_id)
                                }
                              />
                            </td>
                            <td>{order.lead_name || "-"}</td>
                            <td>{order.order_id}</td>
                            <td>{order.partner ? order.partner.name : "-"}</td>
                            <td>
                              {this.renderStatus(
                                order.status,
                                order.cancel_reason,
                                order.order_id,
                              )}
                            </td>
                            <td>{order.payment_type || "-"}</td>
                            <td>
                              {order.is_claim_order ? (
                                <span
                                  className="label label-info"
                                  style={{ background: "#FF9100" }}
                                >
                                  Claim
                                </span>
                              ) : (
                                <span
                                  className="label label-default"
                                  style={{ background: "#8C56D4" }}
                                >
                                  Standard
                                </span>
                              )}
                              <div
                                style={{
                                  marginTop: "6px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {order.order_date
                                  ? String(order.order_date).split(/[ T]/)[0]
                                  : "-"}
                              </div>
                            </td>
                            <td>{order.claim_value}</td>
                             

                            <td>{order.used_credit_points}</td>
                            <td>{order.total_amount}</td>
                            <td>{order.collecting_amount}</td>
                            <td>{this.renderFileButton(order, "bill")}</td>
                            <td>
                              {this.renderFileButton(order, "prescription")}
                            </td>
                          </tr>
                        ))}
                      {!this.state.loading && !orders.length && (
                        <tr>
                          <td colSpan="14" className="text-center">
                            No pickup orders found.
                          </td>
                        </tr>
                      )}
                      {this.state.loading && (
                        <tr>
                          <td colSpan="14" className="text-center">
                            Loading pickup orders...
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <div className="text-right">
                    {this.state.total} orders &nbsp;
                    <Button
                      disabled={currentPage <= 1}
                      onClick={() => this.loadOrders(currentPage - 1)}
                    >
                      Previous
                    </Button>{" "}
                    <span>
                      Page {currentPage} of {lastPage}
                    </span>{" "}
                    <Button
                      disabled={currentPage >= lastPage}
                      onClick={() => this.loadOrders(currentPage + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </Panel.Body>
              </Panel>
            </Col>
          </Row>
        </Grid>
        {this.state.fileModal && (
          <Modal
            show
            onHide={() => this.setState({ fileModal: null })}
            className="pickup-files-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {this.state.fileModal.title} - Order #
                {this.state.fileModal.orderId}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="pickup-file-list">
                {this.state.fileModal.files.map((file, index) => (
                  <div
                    className="pickup-file-list-item"
                    key={file.id || `${this.state.fileModal.urlKey}-${index}`}
                  >
                    <div>
                      <strong>
                        {file.type || this.state.fileModal.title.slice(0, -1)}{" "}
                        {index + 1}
                      </strong>
                      <div className="pickup-file-meta">
                        {file.file_type ? file.file_type.toUpperCase() : "File"}
                        {file.created_at ? ` \u2022 ${file.created_at}` : ""}
                      </div>
                    </div>
                    <Button
                      bsStyle="info"
                      bsSize="small"
                      componentClass="a"
                      href={file[this.state.fileModal.urlKey]}
                      target="_blank"
                      rel="noopener noreferrer"
                      disabled={!file[this.state.fileModal.urlKey]}
                    >
                      <i className="fa fa-external-link" aria-hidden="true" />{" "}
                      View
                    </Button>
                  </div>
                ))}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ fileModal: null })}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <Modal
          show={this.state.showStatusConfirmation}
          onHide={() => this.setState({ showStatusConfirmation: false })}
          className="pickup-status-confirmation-modal"
          backdrop={this.state.updatingStatuses ? "static" : true}
        >
          <Modal.Header closeButton={!this.state.updatingStatuses}>
            <Modal.Title>Confirm status change</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="pickup-confirmation-content">
              <div className="pickup-confirmation-icon" aria-hidden="true">
                <i className="fa fa-refresh" />
              </div>
              <div>
                <p className="pickup-confirmation-message">
                  Change {this.state.selectedOrderIds.length}{" "}
                  {this.state.selectedOrderIds.length === 1
                    ? "order"
                    : "orders"}{" "}
                  to{" "}
                  <strong>
                    {
                      (
                        PICKUP_STATUSES.find(
                          (status) =>
                            status.id === Number(this.state.bulkStatus),
                        ) || {}
                      ).label
                    }
                  </strong>
                  ?
                </p>
                <p className="pickup-confirmation-help">
                  The selected orders will be updated immediately.
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={this.state.updatingStatuses}
              onClick={() => this.setState({ showStatusConfirmation: false })}
            >
              Cancel
            </Button>
            <Button
              bsStyle="info"
              disabled={this.state.updatingStatuses}
              onClick={this.confirmStatusUpdate}
            >
              {this.state.updatingStatuses ? "Updating..." : "Confirm change"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PickupOrders;
